<template>
	<div class="body-box">
		<div class="body">
			<div class="main flex">
				<div class="sign flex-column flex-center">
					<div class="logo">
						<img src="@/assets/image/logo_login.png" alt="">
					</div>
					<p class="title">鲁沃夫运营管理</p>
				</div>
				<div class="login">
					<h1 class="title">账号登录<span>ACCOUNT LOGIN</span></h1>
					<form @submit.prevent="login">
						<div class="item">
							<i class="tf tf-username"></i>
							<input v-model="username" type="text" placeholder="请输入用户名">
						</div>
						<div class="item">
							<i class="tf tf-password"></i>
							<input v-model="password" type="password" placeholder="请输入密码">
						</div>
						<c-button width="364" height="48" font-size="18">登录</c-button>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CryptoJs from '@/assets/script/lib/crypto-js'
	import validate from '@/assets/script/validate.js'
	
	export default {
		data() {
			return {
				username: '',
				password: ''
			}
		},

		methods: {
			login() {
				validate({
					user_name: this.username.trim(),
					user_pwd: this.password.trim()
				}, {
					rule: {
						user_name: [{
							type: 'empty',
							word: '请输入用户名'
						}],
						user_pwd: [{
							type: 'empty',
							word: '请输入密码'
						}]
					},
					success: data => {
						data.user_pwd = CryptoJs.MD5(data.user_pwd).toString();
						
						this.request({
							url: '/sys_user/login',
							data: data,
							loading: true,
							success: data => {
								this.$store.commit('setSession', data.user_info.session);
								this.$store.commit('setUserInfo', data.user_info);
								this.$store.commit('setNav', data.user_menu_list[0] ? data.user_menu_list[0].child_menu_list : []);
								this.$store.commit('setPowers', Array.from(data.user_menu_key_list, item => item.menu_unique_key));
								this.navigateTo('/');
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.body {
		height: 100vh;
		background-image: url('~@/assets/image/login_bg.png');
		background-position: center;
		background-repeat: no-repeat;
		background-size: 1920px auto;
		
		&-box {
			background: linear-gradient(130deg, #9f0910, #153a8f);
		}

		.main {
			position: fixed;
			left: 50%;
			top: 50%;
			width: 590px;
			height: 320px;
			border-radius: 4px;
			overflow: hidden;
			background: #fff;
			transform: translate(-50%, -50%);

			.sign {
				width: 184px;
				background: #F2F2F2;
				
				.logo {
					height: 70px;
					overflow: hidden;
					text-align: center;
				}
				
				.title {
					margin: 10px 0 40px;
					font-size: 20px;
				}
			}
			
			.login {
				padding: 0 40px 0 28px;
				
				.title {
					margin: 42px 0 36px;
					font-size: 18px;
					
					span {
						margin-left: 12px;
						font-size: 12px;
						font-weight: normal;
						color: #aaa;
					}
				}

				.item {
					position: relative;
					margin-bottom: 15px;

					.tf {
						position: absolute;
						left: 14px;
						top: 50%;
						font-size: 14px;
						color: #3E404D;
						transform: translate(0,-50%);
					}

					input {
						box-sizing: border-box;
						width: 100%;
						height: 44px;
						padding: 0 10px 0 36px;
						border: 1px solid #ddd;
						transition: all .2s ease;

						&:hover,
						&:focus {
							border-color: #aaa;
						}
					}
				}
				
				.c-button {
					margin-top: 5px;
				}
			}
		}

		.code {
			p {
				margin: 70px 0 28px;
				font-size: 18px;
				font-weight: bold;
			}

			form {
				position: relative;
				overflow: hidden;

				input {
					width: 310px;
					height: 48px;
					padding: 0 10px;
					border: 1px solid #ddd;
					border-radius: 4px 0 0 4px;
					transition: all .2s ease;

					&:focus {
						border-color: #2F7BFF;
					}
				}

				span {
					position: absolute;
					right: 100px;
					top: 50%;
					font-size: 13px;
					color: #2F7BFF;
					transform: translate(0, -50%);
					cursor: pointer;

					&.z-dis {
						color: #999;
					}
				}

				button {
					width: 90px;
					height: 50px;
					border-radius: 0 4px 4px 0;
				}
			}
		}
	}
</style>
